// Selector de departamento, provincia y distrito del carrito (Perú).
// Guarda la elección en los atributos del carrito y, al pagar, abre el checkout con Región y Ciudad
// precargadas. Si los datos no cargan, el selector se oculta y el checkout funciona como siempre.

const LIMA = '15';
const LIMA_PROVINCIA = '1501';
const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const datosPorUrl = new Map();

// Una sola descarga por URL; si falla, el siguiente intento vuelve a pedirla.
function cargarDatos(src) {
  if (!datosPorUrl.has(src)) {
    datosPorUrl.set(src, fetch(src).then((r) => {
      if (!r.ok) throw new Error(`ubigeo ${r.status}`);
      return r.json();
    }).catch((e) => {
      datosPorUrl.delete(src);
      throw e;
    }));
  }
  return datosPorUrl.get(src);
}

// El carrito lateral carga este script con data-ubigeo-src: la lista se baja en segundo plano
// y ya está lista cuando se abre el carrito.
const etiqueta = document.querySelector('script[data-ubigeo-src]');
if (etiqueta) {
  const precargar = () => cargarDatos(etiqueta.dataset.ubigeoSrc).catch(() => {});
  if ('requestIdleCallback' in window) window.requestIdleCallback(precargar, { timeout: 4000 });
  else setTimeout(precargar, 1500);
}

function opcion(valor, texto, seleccionada) {
  const o = document.createElement('option');
  o.value = valor;
  o.textContent = texto;
  o.selected = seleccionada;
  return o;
}

class PrimalUbigeo extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.iniciado) return;
    this.dataset.iniciado = '1';
    this.sel = {
      departamento: this.querySelector('[data-nivel="departamento"]'),
      provincia: this.querySelector('[data-nivel="provincia"]'),
      distrito: this.querySelector('[data-nivel="distrito"]'),
    };
    this.error = this.querySelector('.primal-ubigeo__error');
    try {
      this.datos = await cargarDatos(this.dataset.src);
    } catch (e) {
      this.hidden = true;
      return;
    }

    const guardado = this.dataset.ubigeo || '';
    this.llenarDepartamentos(guardado.slice(0, 2) || LIMA);
    this.llenarProvincias(guardado.slice(0, 4));
    this.llenarDistritos(guardado);
    Object.values(this.sel).forEach((s) => { s.disabled = false; });
    this.marcarCompleto();

    this.sel.departamento.addEventListener('change', () => {
      this.llenarProvincias('');
      this.llenarDistritos('');
      this.alCambiar();
    });
    this.sel.provincia.addEventListener('change', () => {
      this.llenarDistritos('');
      this.alCambiar();
    });
    this.sel.distrito.addEventListener('change', () => this.alCambiar());
  }

  llenarDepartamentos(elegido) {
    this.sel.departamento.replaceChildren(
      ...this.datos.d.map(([codigo, nombre]) => opcion(codigo, nombre, codigo === elegido))
    );
  }

  // Lima arranca en la provincia de Lima; un departamento con una sola provincia (Callao) la deja elegida.
  llenarProvincias(elegida) {
    const lista = this.datos.p[this.sel.departamento.value] || [];
    if (!elegida && this.sel.departamento.value === LIMA) elegida = LIMA_PROVINCIA;
    if (!elegida && lista.length === 1) elegida = lista[0][0];
    this.sel.provincia.replaceChildren(
      opcion('', 'Elige', !elegida),
      ...lista.map(([codigo, nombre]) => opcion(codigo, nombre, codigo === elegida))
    );
  }

  llenarDistritos(elegido) {
    const lista = this.datos.x[this.sel.provincia.value] || [];
    this.sel.distrito.replaceChildren(
      opcion('', 'Elige tu distrito', !elegido),
      ...lista.map(([codigo, nombre]) => opcion(codigo, nombre, codigo === elegido))
    );
  }

  // { departamento, provincia, distrito, ubigeo, region } o null si falta el distrito.
  destino() {
    const ubigeo = this.sel.distrito.value;
    if (!ubigeo) return null;
    const texto = (s) => s.options[s.selectedIndex].textContent;
    const depto = this.datos.d.find(([codigo]) => codigo === this.sel.departamento.value);
    return {
      departamento: texto(this.sel.departamento),
      provincia: texto(this.sel.provincia),
      distrito: texto(this.sel.distrito),
      ubigeo,
      region: this.datos.z[this.sel.provincia.value] || depto[2],
    };
  }

  marcarCompleto() {
    this.toggleAttribute('data-completo', !!this.sel.distrito.value);
  }

  mostrarError() {
    this.toggleAttribute('data-error', true);
    this.error.hidden = false;
    this.sel.distrito.focus();
    this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  alCambiar() {
    this.marcarCompleto();
    if (this.sel.distrito.value) {
      this.removeAttribute('data-error');
      this.error.hidden = true;
    }
    this.guardar().catch(() => {});
  }

  guardar() {
    const d = this.destino();
    const attributes = d
      ? { Departamento: d.departamento, Provincia: d.provincia, Distrito: d.distrito, Ubigeo: d.ubigeo }
      : { Departamento: '', Provincia: '', Distrito: '', Ubigeo: '' };
    return fetch(`${raiz}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });
  }
}

if (!customElements.get('primal-ubigeo')) {
  customElements.define('primal-ubigeo', PrimalUbigeo);

  // El botón de pago queda en la misma caja (.cart__ctas) que el selector, en el carrito lateral y en /cart.
  document.addEventListener('click', async (evento) => {
    const ctas = evento.target.closest && evento.target.closest('.cart__ctas');
    const selector = ctas && ctas.querySelector('primal-ubigeo');
    if (!selector || selector.hidden || !selector.datos) return;

    const boton = evento.target.closest('button[name="checkout"]');
    const rapido = ctas.querySelector('.additional-checkout-buttons');
    const enRapido = rapido && !selector.sel.distrito.value && (() => {
      const r = rapido.getBoundingClientRect();
      return evento.clientX >= r.left && evento.clientX <= r.right && evento.clientY >= r.top && evento.clientY <= r.bottom;
    })();
    if (enRapido) {
      selector.mostrarError();
      return;
    }
    if (!boton) return;

    evento.preventDefault();
    evento.stopImmediatePropagation();
    const d = selector.destino();
    if (!d) {
      selector.mostrarError();
      return;
    }
    boton.setAttribute('aria-busy', 'true');
    boton.disabled = true;
    try {
      await selector.guardar();
    } catch (e) {
      // El checkout igual se abre; el distrito queda precargado en Ciudad.
    }
    const p = new URLSearchParams();
    p.set('checkout[shipping_address][country]', 'PE');
    p.set('checkout[shipping_address][province]', d.region);
    p.set('checkout[shipping_address][city]', d.distrito);
    window.location.href = `${raiz}checkout?${p.toString()}`;
  }, true);

  // Al volver con el botón Atrás, la página puede restaurarse con el botón de pago desactivado.
  window.addEventListener('pageshow', (evento) => {
    if (!evento.persisted) return;
    document.querySelectorAll('button[name="checkout"][aria-busy]').forEach((b) => {
      b.disabled = false;
      b.removeAttribute('aria-busy');
    });
  });
}
